import { styled } from '@mui/material'

export const ProductContainer = styled('div')(({ theme }) => ({
    padding: theme.spacing(2),
}))

export const ExpandDetailsContainer = styled('div')(({ theme }) => ({
    marginTop: theme.spacing(4),
}))
